import PropTypes from "prop-types";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import { forwardRef, useState } from "react";
import { signOut } from "next-auth/react";
import { CgProfile } from "react-icons/cg";
import { FaSignInAlt, FaSignOutAlt, FaUser } from "react-icons/fa";
import { IoChevronDownSharp } from "react-icons/io5";

const LinkableImage = forwardRef(function LinkableImage(props, ref) {
  const { onClick, href, ...rest } = props;
  return (
      <a href={href} onClick={onClick} ref={ref}>
          <Image {...rest} />
      </a>
  );
});
LinkableImage.displayName = "LinkableImage";

const CustomerNavbar = ({ navItems, full_name, avatar, isAuthenticated,handleProtectedRouteClick,setAuthDialogOpen }) => {
  const router = useRouter();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const isActive = (href) => {
    if (href === "/customer") {
      return router.pathname === href;
    }
    return router.pathname === href || router.pathname.startsWith(href + "/");
  };

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleDropdown();
    }
  };

  return (
    <div dir="ltr" className="hidden md:flex justify-between items-center bg-white sticky top-0 z-50 px-6 lg:px-12 border-b h-20">
      {/* Navigation Links (Left) */}

      <div className="flex justify-between items-center gap-4">

        {/* Logo (Center) */}
        <div className="flex-shrink-0">
          <Link href="/customer" passHref>
            <LinkableImage
              src="/tqneen/brand.svg"
              width={60}
              height={60}
              alt="Brand Logo"
              className="mx-auto"
            />
          </Link>
        </div>
        <div className="flex flex-row-reverse gap-4 lg:gap-6 text-base lg:text-lg">
          {navItems.map((item) => (
            <Link prefetch={false} key={item.href} href={item.href} >
              <span
                onClick={(e) => {
                  
                  handleProtectedRouteClick?.(e, item.href)
                  
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleProtectedRouteClick?.(e, item.href);
                  }
                }}
                role="button"
                tabIndex="0"
                className={`px-3 py-2 rounded-full cursor-pointer transition text-center
                ${isActive(item.href)
                    ? "bg-customer-primary text-white"
                    : "text-customer-primary hover:bg-primary-light"
                  }
              `}
              >
                {item.title}
              </span>
            </Link>
          ))}
        </div>

      </div>


      {/* Profile Section (Right) */}
      <div className="relative">
        {isAuthenticated ? <div
          className="flex items-center gap-2 bg-primary-light px-3 py-2 rounded-full hover:bg-customer-primary/20 transition"
        >
          <Link href="/profile" className="flex-shrink-0" passHref>
            <LinkableImage
              src={avatar}
              alt="User Avatar"
              width={40}
              height={40}
              className="rounded-full object-cover w-10 h-10 cursor-pointer"
            />
          </Link>
          <button
            className="flex items-center gap-2 text-left"
            onClick={toggleDropdown}
            onKeyDown={handleKeyDown}
            aria-expanded={isDropdownOpen}
            aria-haspopup="true"
          >
            <div className="flex flex-col">
              <span className="text-customer-primary font-semibold text-sm">
                {full_name}
              </span>
              <span className="text-gray-500 text-xs">
                حسابي
              </span>
            </div>
            <IoChevronDownSharp className="text-customer-primary" size={20} />
          </button>
        </div> : <>
                  <button
                    className="flex items-center justify-between w-full px-4 py-2 text-gray-700 hover:bg-gray-100 text-sm"
                   
                    onClick={()=>setAuthDialogOpen(true)}
                  >
                    <span>تسجيل الدخول</span>
                    <Image
            src={avatar}
            alt="User Avatar"
            width={40}
            height={40}
            className="rounded-full object-cover w-10 h-10"
          />
                    {/* <FaSignInAlt size={20} /> */}
                  </button>
                </> }

        {/* Dropdown Menu */}
        {isDropdownOpen && (
          <div
            className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-50 border"
            role="menu"
          >
            {isAuthenticated && (
              <>
                <Link href="/profile">
                  <button
                    className="flex items-center justify-between w-full px-4 py-2 text-gray-700 hover:bg-gray-100 text-sm"
                    role="menuitem"
                    onClick={toggleDropdown}
                  >
                    <span>الحساب</span>
                    <CgProfile size={20} />
                  </button>
                </Link>
                <button
                  className="flex items-center justify-between w-full px-4 py-2 text-gray-700 hover:bg-gray-100 text-sm"
                  onClick={() => {
                    signOut();
                    toggleDropdown();
                  }}
                  role="menuitem"
                >
                  <span>تسجيل الخروج</span>
                  <FaSignOutAlt size={20} />
                </button>
              </>
            ) 
            
            // : (
            //   <>
            //     <>
            //       <button
            //         className="flex items-center justify-between w-full px-4 py-2 text-gray-700 hover:bg-gray-100 text-sm"
                   
            //         onClick={()=>setAuthDialogOpen(true)}
            //       >
            //         <span>تسجيل الدخول</span>
            //         {/* <FaSignInAlt size={20} /> */}
            //       </button>
            //     </>
            //     {/* <Link href="/sign-up?t=customer">
            //       <button
            //         className="flex items-center justify-between w-full px-4 py-2 text-gray-700 hover:bg-gray-100 text-sm"
            //         role="menuitem"
            //         onClick={toggleDropdown}
            //       >
            //         <span>
            //           انشاء حساب
            //         </span>
            //         <FaUser size={20} />
            //       </button>
            //     </Link> */}
            //   </>
            // )
            
            }
          </div>
        )}
      </div>
    </div>
  );
};

CustomerNavbar.propTypes = {
  navItems: PropTypes.array.isRequired,
  full_name: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  handleProtectedRouteClick: PropTypes.func.isRequired,
  setAuthDialogOpen: PropTypes.func.isRequired,
};

export default CustomerNavbar;
